var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"extra-item px-5 py-2.5 border rounded mb-2 mr-2 cursor-pointer inline-block",class:{ selected: _vm.state },on:{"click":_vm.toggle}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }